import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2'; // Import Bar instead of Pie
import { api } from '../../../api'; // Import api module correctly
import Cookies from 'js-cookie';

const CircleChart = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const company_id = Cookies.get('company_id');
    api.get(`countstockitemscategorywiseSTM.php?company_id=${company_id}`)
      .then(response => {
        const result = response.data;
        if (result.status === 'success' && Array.isArray(result.products)) {
          const categoryData = result.products.map(item => ({
            label: item.product_name,
            value: parseInt(item.available_stock)
          }));

          // Find the indices of the 1st and 2nd highest values
          const sorted = [...categoryData]
            .map((item, idx) => ({ ...item, idx }))
            .sort((a, b) => b.value - a.value);
          const firstIdx = sorted[0]?.idx;
          const secondIdx = sorted[1]?.idx;

          // Custom colors: 1st and 2nd highest get highlight, others use light gray
          const highlightColor = '#FFCC99'; // Use the color from your screenshot
          const lightGray = '#E5E5E5'; // Light gray for other bars
          const barColors = categoryData.map((_, idx) => {
            if (idx === firstIdx || idx === secondIdx) return highlightColor;
            return lightGray;
          });

          setData({
            labels: categoryData.map(item => item.label),
            datasets: [{
              label: 'Item Counts', // Label for the dataset
              data: categoryData.map(item => item.value),
              backgroundColor: barColors,
            }],
          });
        } else {
          console.error('Error fetching data:', result.message || 'products is not an array');
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <div>
      {data ? (
        <Bar
          data={data}
          options={{
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0, // Set a minimum value for the y-axis scale
                }
              }]
            }
          }}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default CircleChart;



